import { _transformCurrency } from '@freelancer/datastore/currencies';
import { transformSkill } from '@freelancer/datastore/skills';
import { ContestApi, ContestStatusApi } from 'api-typings/contests/contests';
import { Contest } from './contests.model';

export function transformContest(contest: ContestApi): Contest {
  if (
    !contest.currency ||
    !contest.owner_id ||
    !contest.seo_url ||
    !contest.status ||
    !contest.type
  ) {
    throw new ReferenceError(`Missing a required contest field.`);
  }

  return {
    id: contest.id,
    currency: _transformCurrency(contest.currency),
    description: contest.description || '',
    jobs: (contest.jobs || []).map(job => transformSkill(job)),
    ownerId: contest.owner_id,
    seoUrl: contest.seo_url ? contest.seo_url.replace(/\.html$/, '') : '',
    status: contest.status,
    title: contest.title || '',
    type: contest.type,
    timeSubmitted: contest.time_submitted
      ? contest.time_submitted * 1000
      : undefined,
    timePosted: contest.time_posted ? contest.time_posted * 1000 : undefined,
    timeEnded: contest.time_ended ? contest.time_ended * 1000 : undefined,
    entryCount: contest.entry_count,
    duration: contest.duration,
    prize: contest.prize,
    draft: contest.status === ContestStatusApi.INACTIVE,
  };
}
